import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { slideDownUp } from '../global-app-animations';

@Component({
    selector: 'app-custom-text-area',
    templateUrl: './custom-text-area.component.html',
    styleUrls: ['./custom-text-area.component.scss'],
    animations: [slideDownUp],
    standalone: false
})
export class CustomTextAreaComponent implements OnInit, AfterViewInit {
  @ViewChild('inputEl') inputEl: HTMLInputElement | undefined;
  @Input() field!: FieldConfig;
  @Input() group!: FormGroup;


  @Output() changeValue: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      document.getElementById(this.field.name)!.focus();
    }*/
    // this will make all the text area automatically change size
    document.querySelectorAll("textarea").forEach(function (textarea) {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden";

      textarea.addEventListener("input", function () {
        this.style.height = "auto";
        this.style.height = this.scrollHeight + "px";
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  onFocus(event: any) {
    const elem = event.target || event.srcElement;
    elem.select();
  }

  onChangeValue(event: any) {
    this.changeValue.emit(event);
  }
}
